module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_gallery-5e5c14f4b8f63554b177fe3a2846a3f4.svg";